<template>
    <AppMainSearchCard :tituloTela="tituloTela" :isLoading="isLoadingFarmacos"
        @add="$router.push({ path: '/farmaco' })">

        <v-layout wrap row justify-center>
            <v-flex class="item" xs11 md11 lg11 pb-2>
                <v-text-field v-model="search" append-icon="fas fa-search" label="Pesquise por Identificador, Nome, Carência, Via de Administração ou Código na empresa" 
                single-line hide-details outlined clearable ></v-text-field>
            </v-flex>
        </v-layout>

        <v-layout row wrap justify-center pa-3>
            <v-flex class="item" sm11 xs11 md12 lg12>
                <v-data-table :headers="headers" :search="search" @click:row="editItem"
                    no-results-text="Nenhum registro encontrado" :loading="isLoadingFarmacos"
                    :must-sort="true" :items="farmacos" color="secondary"
                    loading-text="Carregando registros...aguarde">
                </v-data-table>
            </v-flex>
        </v-layout>
    </AppMainSearchCard>
</template>

<script>
import AppMainSearchCard from '@/components/layout/AppMainSearchCard.vue'

export default {
    components: {
        AppMainSearchCard,
    },
    data: () => ({
        rowsPerPageItems: [5, 10, 15],
        pagination: {'sortBy': 'idFarmaco', 'descending': true, 'rowsPerPage': 5},
        tituloTela: 'Pesquisa de Medicamentos',
        registroSelected: '',
        headers: [            
            { text: 'Identificador', value: 'idFarmaco' },
            { text: 'Nome', value: 'nmNome' },
            { text: 'Carência', value: 'nrDiasCarencia' },
            { text: 'Via de Administração', value: 'dsViaAdministracao' },
            { text: 'Código na empresa', value: 'nrExterno' },
        ],
        farmacos: [],
        isLoadingFarmacos: false,
        isErrorFarmaco: false,
        query: {},
        search: '',
    }),
		computed: {
        listTiposAdministracao() {
        	return [
	          {
	              stTipo: 'RA',
	              dsTipo: 'Ração'
	          },
						...this.$store.state.tiposAdmFarmaco,
        ]},
		},
    methods: {
        initViewFromRoute(route) {
            this.$store.dispatch('actLoadTiposFarmaco')
            this.$store.dispatch('actLoadLaboratorios')
            this.$store.dispatch('actLoadPrincipiosAtivos')
            this.query = Object.assign({}, route.query)
            this.searchItem()
        },
        editItem (value) {
            this.$router.push({ name: 'farmaco', params: { id : value.idFarmaco } })
        },
        searchItem() {
            var search = Object.assign({}, this.query)

            this.isLoadingFarmacos = true
            var context = this
            this.$axios.get('farmaco/', { params: search })
            .then((response) => {
                if (response.data[0].data != null)
                {
                    let data = response.data[0].data.map(entry => {
                        let dsViaAdministracao = ''
	                      if(entry.csTipoAdm) {
	                      	const tipoAdm = context.listTiposAdministracao.find(i => i.stTipo === entry.csTipoAdm)
		                      dsViaAdministracao = tipoAdm ? tipoAdm.dsTipo : ''
	                      }
                        return {...entry, dsViaAdministracao}
                    })
                    context.farmacos = data
                }
            })
            .catch((error) => {
                this.isErrorFarmaco = true
                this.$store.commit("setSnack", { type: "error", msg: error })
            })
            .finally(() => {
                this.isLoadingFarmacos = false
            })
        },
        routeUpdate() {
            this.$router.push({ path : 'farmacoSearch', query: this.query })
        },
    },
    mounted () {
        this.initViewFromRoute(this.$route)
    },
    watch: {
        options: {
            handler () {
                this.searchItem()
            },
            deep: true
        }
    },
    beforeRouteUpdate(to, from, next){
        this.initViewFromRoute(to)
        next()
    }
}
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
